<!--AFFICHAGE BLOC GOOGLE -->
<template>
  <v-col
    md="12"
    class="pa-3 d-flex flex-column"
    v-if="this.condition()"
  >
  <a class="anchor" id="blocflotte"></a>

    <v-card elevation="2">
      <v-card-title> Flotte automobile </v-card-title>
      <v-card-text >

          <v-data-table
              v-if="this.flotte != null"
              dense
              :headers="headers"
              :items="flotte"
              item-key="nom"
              class="elevation-1"
            >
             <template #item.proprietaire="{ item }">{{ item.proprietaire ? "Oui" : "Non" }}</template>
             <template #item.acquisAu1erJanvier="{ item }">{{ item.proprietaire ? "Oui" : "Non" }}</template>
            </v-data-table>

      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>

export default {
  name: "Flotte",
  props: [""],
  components: {
  },
   data: () => ({
        search: '',
        filter: {},
        sortDesc: false,
        page: 1,
        itemsPerPage: 10,
    }),
  computed: {

    flotte: function () {
      return this.$store.getters.getbloc("equipement", "donnees","flotte", null, "valeur");
    },

    headers() {
      return [
        {
          text: "Marque",
          align: "start",
          value: "marque",
          fixed: true,
          width: "10px",
        },
        {
          text: "Modèle",
          value: "modele",
          align: "start",
          fixed: true,
          width: "100px",
        },
        {
          text: "Propriétaire",
          value: "proprietaire",
          align: "start",
          fixed: true,
          width: "100px",
        },
           {
          text: "Acquis au 1e Janvier",
          value: "acquisAu1erJanvier",
          align: "start",
          fixed: true,
          width: "100px",
        },
      ];
    },
  },
  methods: {
    condition() {
      var flotte =  this.$store.getters.getbloc("equipement", "donnees","flotte", null, "valeur");
      return flotte !=null && flotte.length>0
    },
  },
};
</script>
